import { RealTimeFinancialHealthReportRequest } from './real-time-financial-health-report-request';

export class RealTimeFinancialHealthReportPdfRequest extends RealTimeFinancialHealthReportRequest {

  dxPngFormData: FormData;

  constructor(propertyId: string, fiscalYear: number, dxPngFormData: FormData) {
    super(propertyId, fiscalYear);

    this.dxPngFormData = dxPngFormData;
  }
}
